import V from 'voUtils/V.js';

export default {
	props: {
		carouselId: String
	},

	mounted: function () {
		$("#owl-" + 'startblog').owlCarousel({
			items: 2,
			loop: false,
			autoplay: false,
			dots: false,
			smartSpeed: 1000,
			nav: true,
			autoplayTimeout: 10000,
			responsive: {

				0: {
					items: 1
				},

				768: {
					items: 2
				},
				992: {
					items: 3
				}
			}
		});
	}
};